import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import InputBox from 'src/components/inputbox/InputBoxOnBlur';
import ArrowBackIcon from '@mui/icons-material/KeyboardArrowLeft';
import { FormState, useSignFormStore } from 'src/stores/SignFormStore';
import InputBoxState from 'src/components/inputbox/InputBoxState'
import InputBoxChildren from 'src/components/inputbox/InputBoxOnBlurChildren'
import { postCheckUserId, postAuthEmail } from 'src/api/User';
import ButtonSignUp from 'src/components/buttons/ButtonSignUp';
import CountdownTimer from 'src/utils/CountdownTimer'
import { TempUserStore } from 'src/stores/UserInfoStore';
import { useNavbarStore } from 'src/stores/UIStore';
import { NextButtonWrapper } from 'src/components/common/CommonStyled';
// styled-components를 사용하여 페이지 컨테이너 스타일을 정의합니다.
// 기존 SignUpDetailsContainer 스타일 정의
const SignUpDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0px 20px;
  background-color: white;
  box-sizing: border-box;
  overflow-y: auto;  // 스크롤 추가
  max-height: calc(100vh - 144px);
  overflow-x: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
`

const Title = styled.h1`
  text-align: center;
  font-weight: bold;
  font-size: 18px;
`;

const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 1rem;
`;

const FormFieldLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 10px;
  width: 100%;
  color: gray; // 라벨의 색상을 회색으로 설정합니다.
`;

const FormInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
  height: 46px;
`;

const ActionButton = styled.button<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "#F5F5F5"
      : "white"};
  color: ${({ disabled }) =>
    disabled
      ? "#7A7A84"
      : "#0AB2E4"};
  padding: 13px 17px ;
  white-space: nowrap;
  font-size: 16px ;
  font-weight: 500 ;
  height: 100%;
  border: 1px solid ${({ disabled }) =>
    disabled
      ? "#F5F5F5"
      : "#0AB2E4"};
  border-radius: 5px;
  font-family: 'Pretendard';
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AlertSpan = styled.span<{ $isValid: boolean }>`
  color:${({ $isValid }) => ($isValid ? "#39B95B" : "#FF5A5A")};
  font-size: 14px;
  font-weight:500;
  padding:10px;
`

const SignUpDetails = () => {
  const navigate = useNavigate();
  const setField = useSignFormStore((state) => state.setField);
  const id = useSignFormStore((state) => state.id);
  const reset = useSignFormStore((state)=>state.reset)
  const email = useSignFormStore((state)=>state.email)
  const passwordConfirm = useSignFormStore((state)=>state.passwordConfirm)
  const password = useSignFormStore((state)=>state.password)
  // const armyNumber = useSignFormStore((state)=>state.armyNumber)
  const name = useSignFormStore((state)=>state.name)
  const contact = useSignFormStore((state)=>state.contact)
  const [idFirstCheck,setIdFirstCheck] = useState(false)
  const [isIdRegex,setIdRegex] = useState(true)
  const [isIdValid,setIsIdValid] = useState(true)
  const [isPasswordRegex,setIsPasswordRegex] = useState(true)
  const [isPasswordValid,setIsPasswordValid] = useState(true)
  // const [isArmyNumberRegex,setIsArmyNumberRegex] = useState(true)
  const [isNameRegex,setIsNameRegex] = useState(true)
  const [isPhoneNumberRegex,setIsPhoneNumberRegex] = useState(true)
  const [isEmailRegex,setIsEmailRegex] = useState(true)
  const [isEmailVaild,setIsEmailVaild] = useState(true)
  const [isPhoneVaild,setIsPhoneVaild] = useState(true)
  const [authCode,setAuthCode] = useState('')
  const [inputAuthCode,setInputAuthCode] = useState('')
  const [authCodeVerify,setAuthCodeVerify] = useState(true)
  const [authCodeValid,setAuthCodeValid] = useState(true)
  const [isEmailVerify,setIsEmailVerify] = useState(false)
  const [isTimeout,setIsTimeout] = useState(false)
  const [resetTimer,setResetTimer] = useState(0)
  const setTempField = TempUserStore((state)=>state.setField)
  const setNavField= useNavbarStore((state)=>state.setField)

   useEffect(()=>{
      setNavField('isvisible',false)
        return()=>{
          reset()
          setNavField('isvisible',true)
        }
    },[])

  const isFormValid = [
    idFirstCheck,
    isIdRegex,
    isIdValid,
    isPasswordRegex,
    isPasswordValid,
    // isArmyNumberRegex,
    isNameRegex,
    isPhoneNumberRegex,
    isEmailVerify
  ].every(value => value === true);

  const handleIdValid = async ()=>{
    const id = useSignFormStore.getState().id
    const data = await postCheckUserId(id)
    
    setIdFirstCheck(true)
    if (data.exist === false){
      setIsIdValid(true)
    }
    else{
      setIsIdValid(false)
    }
  }

  type FormFieldKey = keyof FormState;

  const validateUserId = ({e,field,regex}:{e:React.FocusEvent<HTMLInputElement>,field:FormFieldKey,regex:RegExp})=>{
    // if (regex.test(e.target.value)){
      useSignFormStore.getState().setField(field, e.target.value);
    // }
    // setIdFirstCheck(false)
    // setIsIdValid(true)
    setIdRegex(regex.test(e.target.value))
  }

  const validatePassword = ({e,field,regex}:{e:React.FocusEvent<HTMLInputElement>,field:FormFieldKey,regex:RegExp})=>{
    // if (regex.test(e.target.value)){
      setField(field,e.target.value)
    // }
    if(field === 'password'){
      setIsPasswordRegex(regex.test(e.target.value))
    }
    if(password === passwordConfirm){
      setIsPasswordValid(true)
    }
    else{
      setIsPasswordValid(false)
    }
  }

  const validateRegex = ({e,field,regex, setState, setState2}:{e:React.FocusEvent<HTMLInputElement>,field:FormFieldKey,regex:RegExp, setState: React.Dispatch<React.SetStateAction<boolean>>, setState2?: React.Dispatch<React.SetStateAction<boolean>>})=>{
    // if (regex.test(e.target.value)){
      setField(field,e.target.value)
    // }
    setState(regex.test(e.target.value))
    setState2?.(true)
  }

  const handleResponse = (response:any) =>{
    if (response.exist === true){
      setIsPhoneVaild(false)
    }
    if (response.data === ""){
      setTempField('userName',id)
      navigate('/signup-deny')
    }

  }

  const [emailCheck,setEmailCheck] = useState(false)
  const handleAuthEmail = async (user_email:string) => {
    if (!user_email) {
      setIsEmailRegex(false)
      return
    }
    if(!isEmailRegex){
      return
    }

    const response = await postAuthEmail(user_email)
    if(response.status === false){
      setIsEmailVaild(false)
      setAuthCode('')
      setIsEmailRegex(true)
      setIsEmailVerify(false)
      return
    }
    setAuthCodeVerify(false);
    setAuthCode(response.code.slice(2));

    setResetTimer((prev) => prev + 1)
    setIsTimeout(false)
    setEmailCheck(true)
  }

  const handleEmailVerify = ()=>{
    if(!authCode) return
    if(inputAuthCode === authCode) {
      setIsEmailVerify(true)
      setAuthCodeValid(true)
      setEmailCheck(false)
    }
    else{
      setIsEmailVerify(false)
      setAuthCodeValid(false)
    }
    setAuthCodeVerify(true)
  }

  return (
    <>
      <HeaderContainer>
        <Title>회원가입</Title>
        <ArrowBackIcon sx={{
          fontSize:24,
          position: 'absolute',
          display:'flex',
          left: '20px'
          }}
          onClick={()=>navigate(-1)}/>
      </HeaderContainer>
      <SignUpDetailsContainer>
      <FormFieldContainer>
        <FormFieldLabel>*아이디
        </FormFieldLabel>
        <FormInputContainer>
          <InputBox
          type="text"
          placeholder='아이디(5~20자, 영문 소문자, 숫자)'
          defaultValue={''}
          onBlur={(e)=>validateUserId({e,field:'id',regex:/^[a-z0-9]{5,20}$/})}
          isValid={isIdValid}/>
          <ActionButton onClick={handleIdValid} disabled={!isIdRegex}>중복확인</ActionButton>
        </FormInputContainer>
        { id !== '' && (
          isIdRegex ? (
            idFirstCheck ? (
              isIdValid ? (
                <AlertSpan $isValid={true}>사용 가능한 아이디입니다.</AlertSpan>
              ) : (
                <AlertSpan $isValid={false}>이미 사용 중인 아이디입니다.</AlertSpan>
              )
            ) : (
              <AlertSpan $isValid={false}>아이디 중복확인을 해주세요.</AlertSpan>
            )
          ) : (
            <AlertSpan $isValid={false}>영문 소문자, 숫자만 사용한 5~20자여야합니다.</AlertSpan>
          )
        )}
        
      </FormFieldContainer>
      <FormFieldContainer>
        <FormFieldLabel>*비밀번호</FormFieldLabel>
        <FormInputContainer>
          <InputBoxState
            type="password"
            placeholder="비밀번호(8~20자, 영문자+숫자+특수문자)"
            defaultValue={''}
            //eslint-disable-next-line
            onBlur={(e)=>validatePassword({e,field:'password',regex:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~\-]).{8,20}$/})}
            state={setIsPasswordValid}
            isValid={!(!isPasswordRegex && password !== '')}
          />
        </FormInputContainer>
        {!isPasswordRegex && password !== '' && (
          <AlertSpan $isValid={false}>
            영문자, 숫자, 특수문자를 모두 포함한 8~20자여야합니다.
          </AlertSpan>
        )}
      </FormFieldContainer>
      <FormFieldContainer>
        <FormFieldLabel>*비밀번호 확인</FormFieldLabel>
        <FormInputContainer>
          <InputBoxState
            type="password"
            placeholder="비밀번호 확인"
            defaultValue=''
            //eslint-disable-next-line
            onBlur={(e) => validatePassword({e,field:'passwordConfirm',regex:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?/~\-]).{8,20}$/})}
            state={setIsPasswordValid}
            isValid={!(!isPasswordValid && passwordConfirm !== '')}
          />
        </FormInputContainer>
        {!isPasswordValid && passwordConfirm !== '' &&(
          <AlertSpan $isValid={false}>
            비밀번호가 일치하지 않습니다.
          </AlertSpan>
        )}
      </FormFieldContainer>
      {/* <FormFieldContainer>
        <FormFieldLabel>*군번</FormFieldLabel>
        <FormInputContainer>
          <InputBox
            type='text'
            placeholder="군번('-' 포함)"
            defaultValue=''
            onBlur={(e) => validateRegex({e,field:'armyNumber',regex:/^[0-9-]{1,11}$/,setState:setIsArmyNumberRegex})}
            isValid={!(!isArmyNumberRegex && armyNumber !== '')}
          />
        </FormInputContainer>
        {!isArmyNumberRegex && armyNumber !== '' && 
        (<AlertSpan $isValid={false}>숫자와 '-'만 사용한 11자이하여야합니다.</AlertSpan>)}
      </FormFieldContainer> */}
      <FormFieldContainer>
        <FormFieldLabel>*이름</FormFieldLabel>
        <FormInputContainer>
        <InputBox
            type='text'
            placeholder="이름"
            defaultValue=''
            onBlur={(e) => validateRegex({e,field:'name',regex:/^[가-힣]{2,5}$/,setState:setIsNameRegex})}
            isValid={!(!isNameRegex && name !== '')}
          />
        </FormInputContainer>
        {!isNameRegex && name !== ''&&
        (<AlertSpan $isValid={false}>한글만 사용한 2~5자여야합니다.</AlertSpan>)}
      </FormFieldContainer>
      <FormFieldContainer>
        <FormFieldLabel>*연락처</FormFieldLabel>
        <FormInputContainer>
          <InputBox
            type='text'
            placeholder="연락처('-' 없이 숫자만 입력)"
            defaultValue=''
            onBlur={(e) => validateRegex({e,field:'contact',regex:/^\d{10,11}$/,setState:setIsPhoneNumberRegex,setState2:setIsPhoneVaild})}
            isValid={(isPhoneNumberRegex && isPhoneVaild) || contact === ''}
          />
        </FormInputContainer>
        {!isPhoneNumberRegex && contact !== '' && (<AlertSpan $isValid={false}>숫자만 사용한 10~11자여야합니다.</AlertSpan>)}
        {!isPhoneVaild && <AlertSpan $isValid={false}>이미 등록된 전화번호입니다.</AlertSpan>}
      </FormFieldContainer>
      <FormFieldContainer>
        <FormFieldLabel>*이메일</FormFieldLabel>
        <FormInputContainer>
          <InputBox
            type='text'
            placeholder="이메일"
            defaultValue=''
            onBlur={(e) => validateRegex({e,field:'email',regex:/^[A-Za-z][A-Za-z0-9._%+-]*[A-Za-z0-9]@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,setState:setIsEmailRegex,setState2:setIsEmailVaild})}
            isValid={(isEmailRegex && isEmailVaild) || email === ''}
            disabled={isEmailVerify}
          />
          {authCode ? 
          <ActionButton disabled={!isTimeout || isEmailVerify}onClick={()=>handleAuthEmail(email)}>
            재전송
          </ActionButton> 
          : 
          <ActionButton onClick={()=>handleAuthEmail(email)}>
            인증번호 전송
          </ActionButton>}
        </FormInputContainer>
        {!isEmailRegex && email !== '' && (<AlertSpan $isValid={false}>올바른 이메일 형식이 아닙니다.</AlertSpan>)}
        {!isEmailVaild && <AlertSpan $isValid={false}>이미 등록된 이메일입니다.</AlertSpan>}
      </FormFieldContainer>
      <FormFieldContainer>
        <FormFieldLabel>*인증번호</FormFieldLabel>
        <FormInputContainer>
        <InputBoxChildren
            type='text'
            placeholder="인증번호"
            defaultValue=''
            onBlur={(e)=>setInputAuthCode(e.target.value)}
            children={
              (!authCodeVerify || !authCodeValid) && <CountdownTimer m={5} resetTrigger={resetTimer} setState={setIsTimeout}/>
            }
            disabled={isEmailVerify}
            isValid={!(!authCodeVerify || !authCodeValid)}
          />
          <ActionButton disabled={email === '' || !emailCheck || isTimeout} onClick={()=>handleEmailVerify()}>
            인증
            </ActionButton>
        </FormInputContainer>
        {!authCodeVerify && <AlertSpan $isValid={false}>인증코드를 입력해주세요.</AlertSpan>}
          {!authCodeValid && <AlertSpan $isValid={false}>인증코드가 틀립니다.</AlertSpan>}
      </FormFieldContainer>
      </SignUpDetailsContainer>
      <NextButtonWrapper $isBorder={true} style={{width:'100vw'}}>
        <ButtonSignUp Check={isFormValid} onResponse={handleResponse}>회원가입 완료</ButtonSignUp>
      </NextButtonWrapper>
    </>
  );
};

export default SignUpDetails;